module.exports = __webpack_public_path__ + "img/lcp_logo_updated.68cbbb77.png";